export default __webpack_public_path__ + "static/media/bundle-kit.291401a5.glb";